import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class ApiService {
  private readonly http = inject(HttpClient);

  get<T>(path: string, params?: HttpParams): Observable<T> {
    return this.http.get<T>(`${environment.apiBaseUrl}${path}`, { params });
  }

  getFromData<T>(path: string, params?: HttpParams): Observable<T> {
    return this.http.get<T>(`${environment.apiDataUrl}${path}`, { params });
  }

  post<T>(path: string): Observable<T> {
    return this.http.post<T>(`${environment.apiBaseUrl}${path}`, null);
  }

  postToData<T>(path: string): Observable<T> {
    return this.http.post<T>(`${environment.apiDataUrl}${path}`, null);
  }
}
